import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import TeacherClazzFields from './TeacherClazzFields'

export const TeacherClazzEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <TeacherClazzFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default TeacherClazzEdit
